<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card class="elevation-10">
          <v-skeleton-loader
            :loading="loading"
            type="table-heading, table-thead, table-row-divider@10, table-tfoot"
          >
            <v-card-actions>
              <v-row>
                <v-col
                  cols="4"
                  md="3"
                  xl="4"
                >
                  <v-toolbar
                    flat
                  >
                    <v-toolbar-title class="md-4 white--text">
                      Company Quota
                    </v-toolbar-title>
                  </v-toolbar>
                </v-col>
                <v-col
                  cols="4"
                  md="3"
                  xl="4"
                >
                  <v-text-field
                    v-model="search"
                    placeholder="Search"
                    append-icon="fa fa-search"
                    label="Search Company Quota"
                    hide-no-data
                    hide-selected
                    clearable
                  />
                </v-col>
                <v-col
                  cols="2"
                  md="3"
                  xl="2"
                />
                <v-col
                  cols="2"
                  md="3"
                  xl="2"
                  class="mt-2 text-right"
                >
                  <company-quota-dialog-mass-edit-or-create
                    @updated="loadData"
                  />
                </v-col>
              </v-row>
            </v-card-actions>
            <v-data-table
              :headers="headers"
              :items="companyQuotaOverview"
              :items-per-page="10"
              :single-expand="true"
              :search="search"
              item-key="id"
              class="scrollable-table elevation-10"
              data-simplebar
              :sort-by="['year', 'company_name']"
            >
              <template v-slot:item="props">
                <tr
                  style="cursor: pointer;"
                  @click="props.expand(!props.isExpanded);
                          selectQuotaCompanyYear(props.item.company_id, props.item.year, props.item.category_id);"
                >
                  <td>
                    <v-btn icon>
                      <v-icon small>
                        {{ props.isExpanded ? 'fa-chevron-up' : 'fa-chevron-down' }}
                      </v-icon>
                    </v-btn>
                    {{ props.item.company_name }}
                  </td>            
                  <td>{{ props.item.year }}</td>
                  <td>{{ (props.item.company_quota_category ? props.item.company_quota_category.value : '-') }}</td>
                  <td 
                    :class="props.item.totalQuota > 500000 ? 'red--text text-right' : 'text-right'"
                  >
                    {{ ((props.item.totalQuota).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
                  </td>
                  <td class="text-right">
                    {{ ((props.item.totalUsedQuota).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
                  </td>
                </tr>
              </template>        
              <template v-slot:expanded-item>
                <td
                  :colspan="headers.length"
                  class="px-0"
                >
                  <v-card class="pa-5">              
                    <v-data-table
                      :headers="childHeaders"
                      :items="filteredCompanyQuota"
                      disable-pagination
                      sort-by="month"
                      hide-default-footer
                      class="elevation-5 secondaryTable"
                    >
                      <template v-slot:[`item.month`]="{ item: childItem }">
                        <div>
                          <span>
                            {{ getHumanMonth(childItem.month) }}
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`item.quota`]="{ item: childItem }">
                        <div>
                          <span>
                            {{ ((childItem.quota).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`item.carry_forward`]="{ item: childItem }">
                        <div>
                          <span>
                            {{ Number(childItem.carry_forward).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'}).substring(3) }}
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`item.quota_used`]="{ item: childItem }">
                        <div>
                          <span>
                            {{ ((childItem.quota_used).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
                          </span>
                        </div>
                      </template>

                      <template v-slot:[`item.balance`]="{ item: childItem }">
                        <div>
                          <span>
                            {{ ((childItem.balance).toLocaleString('en-MY', { style: 'currency', currency: 'MYR'})).substring(3) }}
                          </span>
                        </div>
                      </template>
                    </v-data-table>
                  </v-card>
                </td>
              </template>      
            </v-data-table>
          </v-skeleton-loader>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    data () {
      return {
        loading: true,
        loadingQuotas: [],
        dialog: false,
        companyId: '',
        categoryId: '',
        year: '',
        snack: '',
        snackColor: '',
        snackText: '',
        search: '',
        companyQuotaOverview: [],
        companyQuotas: [],
        headers: [
          { text: 'Company', align: 'left', value: 'company_name' },
          { text: 'Year', align: 'left', value: 'year' },
          { text: 'Category', align: 'left', value: 'company_quota_category.value' },
          { text: 'Total Quota', align: 'right', value: 'totalQuota' },
          { text: 'Total Used Quota', align: 'right', value: 'totalUsedQuota' },
        ],
        childHeaders: [
          { text: 'Month', value: 'month', align: 'left' },
          { text: 'Quota', value: 'quota', align: 'right' },
          { text: 'Carry Forward', value: 'carry_forward', align: 'right' },
          { text: 'Quota Used', value: 'quota_used', align: 'right' },
          { text: 'Balance', value: 'balance', align: 'right' },
        ],
      }
    },
    computed: {
      filteredCompanyQuota () {   
        if (!this.companyId || !this.year) return
        
        return this.companyQuotas.filter(companyQuota => {
          return companyQuota.company_id === this.companyId && companyQuota.year === this.year && companyQuota.category_id === this.categoryId
        })
      },
    },
    created () {
      this.loadData()
    },

    methods: {
      loadData () {
        Promise.all([
          this.$api.companyQuotas().list(),
          this.$api.companyQuotas().overview(),
        ])
          .then(([companyQuotas, companyQuotaOverview]) => {
            this.companyQuotas = companyQuotas.data
            this.companyQuotaOverview = companyQuotaOverview.data
            this.companyQuotaOverview.map(companyQuotaOverview => {
              let totalQuota = 0
              let totalUsedQuota = 0
              let companyName = '-'
              this.companyQuotas.map(companyQuota => {
                if (companyQuotaOverview.company_id === companyQuota.company_id && companyQuotaOverview.year === companyQuota.year && companyQuotaOverview.category_id === companyQuota.category_id) {
                  totalQuota = companyQuota.quota + totalQuota
                  totalUsedQuota = companyQuota.quota_used + totalUsedQuota
                }

                if (companyQuotaOverview.company) {
                  companyName = companyQuotaOverview.company.name
                }
              })
              Object.assign( 
                companyQuotaOverview, 
                { totalQuota: totalQuota, totalUsedQuota: totalUsedQuota, company_name: companyName })
            })
            
            this.loading = false
          }).catch(err => {
            console.log(err)
          })
      },
      selectQuotaCompanyYear (companyId, year, categoryId) {
        this.companyId = companyId
        this.year = year
        this.categoryId = categoryId
      },
      getHumanMonth (number) {
        return this.$moment().month(number - 1).format('MMMM')
      },
    },
  }
</script>

<style scoped>

</style>
